import { render, staticRenderFns } from "./DeletedLabel.vue?vue&type=template&id=313e5496&scoped=true&"
import script from "./DeletedLabel.vue?vue&type=script&lang=js&"
export * from "./DeletedLabel.vue?vue&type=script&lang=js&"
import style0 from "./DeletedLabel.vue?vue&type=style&index=0&id=313e5496&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313e5496",
  null
  
)

export default component.exports